import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { UILanguages } from "../../app/localization/localization";
import { ITenant } from "../../app/models/tenant";
import { getDisplayName, IUser } from "../../app/models/user";
import { RootStoreContext } from "../../app/stores/rootStore";
import MainNavBarAutoOnAirCheckbox from "./MainNavBarAutoOnAirCheckbox";
import MainNavBarAutoSyncCheckbox from "./MainNavBarAutoSyncCheckbox";
import MainNavBarCredentialsLinks from "./MainNavBarCredentialsLinks";
import MainNavBarLanguageSetting from "./MainNavBarLanguageSetting";
import MainNavBarLogoutLink from "./MainNavBarLogoutLink";
import MainNavBarSwitchModeLinks from "./MainNavBarSwitchModeLinks";
import MainNavBarTenantsLinks from "./MainNavBarTenantsLinks";

interface IParams {
  currentTenant: ITenant;
  allTenants: ITenant[];
  user: IUser;
}

const MainNavBarDropdown: React.FC<IParams> = ({
  currentTenant,
  allTenants,
  user,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme, isNativeApp, isOfflineModeEnabled } = rootStore.commonStore;
  const { isToShowAutoOnairCheckBox } = rootStore.screensStore;

  return (
    <>
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav className={theme!.headerTextColor}>
          <i className="far fa-user-circle fa-lg mr-2"></i>
          <i className="fas fa-chevron-down fa-sm"></i>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem>
            <b>{getDisplayName(user)}</b>
          </DropdownItem>
          <DropdownItem divider />
          {!isOfflineModeEnabled && <MainNavBarAutoSyncCheckbox />}
          {isToShowAutoOnairCheckBox && <MainNavBarAutoOnAirCheckbox />}
          <MainNavBarTenantsLinks
            tenants={allTenants.filter((x) => x.id !== currentTenant.id)}
          />
          {isNativeApp && <MainNavBarSwitchModeLinks tenant={currentTenant} />}
          {!isOfflineModeEnabled && <MainNavBarCredentialsLinks />}
          <MainNavBarLanguageSetting UISupportedLanguages={UILanguages}/>
          <MainNavBarLogoutLink />
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
};

export default observer(MainNavBarDropdown);
